import { ChatMessageRelationType } from '@core/types';
import { ChatMessageTime, ChatUserName } from '../..';
import { Reply } from '@core/ui';
import { useTranslation } from 'react-i18next';

export const MessageInfo = ({ relationType, username, time }: { relationType?: ChatMessageRelationType; username: string; time: string }) => {
    const { t } = useTranslation();

    return (
        <div>
            {relationType === ChatMessageRelationType.reply && <span className="italic">{t('Chat.Message.ReplyingTo')}</span>}
            {relationType === ChatMessageRelationType.forward && (
                <span className="italic">
                    <Reply classNames="w-6 h-6 flex-none inline-block mr-1 stroke-current -scale-x-100" />
                    {t('Chat.Message.ForwardedFrom')}
                </span>
            )}
            <ChatUserName username={username} />
            <ChatMessageTime time={time} />
        </div>
    );
};
